import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { formatNumber } from 'utils/formats';

import { RowCell } from 'modules/_shared/Table/types/RowCell';
import TableRow from 'modules/_shared/Table/components/TableRow';

import { HistoryMovement } from 'types';
import movementTypes from 'modules/transactions/constants/movementTypes';

type ReclassificationTableRowProps = {
  index: number;
  movement: HistoryMovement;
};

const ReclassificationTableRow: FC<ReclassificationTableRowProps> = ({
  index,
  movement,
}) => {
  const { t } = useTranslate();

  const isEntireClassReclassification =
    movement.movementType === movementTypes.ENTIRE_CLASS_RECLASSIFICATION;

  const cells = [
    ...(isEntireClassReclassification
      ? [
          {
            key: `movement-entire-${index}`,
            content: t('AllRanges'),
            textPosition: 'center',
            colSpan: 2,
          },
        ]
      : [
          {
            key: `movement-from-${index}`,
            content: formatNumber(movement.from),
            textPosition: 'right',
          },
          {
            key: `movement-to-${index}`,
            content: formatNumber(movement.to),
            textPosition: 'right',
          },
        ]),
    {
      key: `movement-class-${index}`,
      content: movement.holdingClassName,
      textPosition: 'center',
    },
    ...(isEntireClassReclassification
      ? [
          {
            key: `movement-new-entire-${index}`,
            content: '-',
            textPosition: 'center',
            colSpan: 2,
          },
        ]
      : [
          {
            key: `movement-newForm-${index}`,
            content: formatNumber(movement.newFrom),
            textPosition: 'right',
          },
          {
            key: `movement-newTo-${index}`,
            content: formatNumber(movement.newTo),
            textPosition: 'right',
          },
        ]),
    {
      key: `movement-newClass-${index}`,
      content: movement.newHoldingClassName,
      textPosition: 'center',
    },
    {
      key: `movement-action-${index}`,
      content: '',
      textPosition: 'right',
    },
  ] as RowCell[];

  return <TableRow cells={cells} />;
};

export default ReclassificationTableRow;
